<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 17L5.71933 10.791C5.32339 10.3996 5.32337 9.7602 5.71928 9.36876L6.40052 8.69521C6.79014 8.30999 7.41719 8.31002 7.80676 8.69528L12 12.8421L16.1933 8.69528C16.5828 8.31002 17.2099 8.30999 17.5995 8.6952L18.2807 9.36876C18.6766 9.7602 18.6766 10.3996 18.2807 10.791L12 17Z"
      class="fill-current"
    />
  </svg>
</template>
